import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { useState } from "react";
import Home from "./pages/Home";
import About from "./pages/About";
import NewsPage from "./pages/NewsPage";
import NewsDetail from "./pages/NewsDetail";
import FeaturesPage from "./pages/FeaturesPage";
import Contact from "./pages/Contact";
import Breaking from "./pages/Breaking"; 
import Latest from "./pages/BreakingNews";
import Subscribe from "./pages/Subscribe";
import BreakingTicker from "./components/BreakingTicker";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import InstallBanner from "./components/InstallBanner";
import Sitemap from "./pages/Sitemap"; 
function App() {
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);
	return (
		<Router>
			<div className='w-full mx-auto bg-white'>
				<Header />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/about" element={<About />} />
					<Route path="/features" element={<FeaturesPage />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/subscribe" element={<Subscribe />} />   
					<Route path="/latest" element={<Latest />} />   
					<Route path="/breaking" element={<Breaking />} /> 
					<Route path="/news" element={<NewsPage />} />
                    <Route path="/news/:slug" element={<NewsDetail />} />
					      <Route path="/sitemap.xml" element={<Sitemap />} /> 
				   <Route 
            path="/admin" 
            element={
              isAdminLoggedIn ? 
                <Admin /> : 
                <AdminLogin onLogin={() => setIsAdminLoggedIn(true)} />
            } 
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;